var carroceria = [
  'Aabenraa',
  'AAP Smart Coach',
  'Able Bus & Coach',
  'ACF',
  'ACLO',
  'ACM - American Coach de México',
  'Aconcágua',
  'ACS',
  'AEC',
  'Aerobus',
  'AGA',
  'Agrale',
  'ALASA',
  'Alcar',
  'Alexander',
  'Alexander Dennis',
  'Alfredo Caetano',
  'Alstom',
  'Altari',
  'Alvorada',
  'Ambatour - Equador',
  'AMD',
  'AmTran',
  'Anadolu Isuzu',
  'Ancar',
  'Andecar',
  'Ankai',
  'Aple Bus',
  'Apolobus',
  'Apple Bus',
  'Aratu',
  'Arbus',
  'ArMar',
  'Artesanal',
  'Asalde',
  'Ashok Leyland',
  'Asia Motors',
  'Atomic',
  'Austral',
  'Autobus',
  'Autodromo',
  'Autogago',
  'Autosan',
  'Auwaerter',
  'Avalos Buss',
  'Avenida',
  'Avia',
  'Ayats',
  'Ayco',
  'Azirma',
  'Báez',
  'Barbi',
  'BCI',
  'Beccar',
  'BepoBus',
  'Berjaya',
  'Berna',
  'Beulas',
  'BGP',
  'Bi-Met',
  'BLK',
  'Blue Bird',
  'Blue Solutions',
  'Bluebird',
  'BMC',
  'Bonluck Bus',
  'Bons Amigos',
  'Borsani',
  'Bova',
  'Brasinca',
  'Breda-Pistoiesi',
  'Bredabus',
  'BredaMenarinibus',
  'Brice',
  'BRK',
  'Bruce',
  'Bus',
  'Busscar',
  'Busscar Colômbia',
  'Büssing',
  'BYD',
  'Cacciamali',
  'CaetanoBus',
  'CAIO',
  'Cametal',
  'CAMI',
  'Camilo Bus',
  'CAMO',
  'Campeon',
  'CAndinas',
  'Car Lid',
  'Carbrasa',
  'Caricar',
  'Carpenter',
  'Carrocería Avenida',
  'Carrocería Cebra Moreno',
  'Carrocería Dávalos',
  'Carrocería El Catorce',
  'Carrocería Luis López',
  'Carrocería Pintolin Alvorada',
  'Carrocería San Blas',
  'Carroceria San Carlos',
  'Carrocería San Fernando',
  'Carrocería San Francisco',
  'Carrocerias Aguila',
  'Carrocerías Anahi',
  'Carrocerías Cano',
  'Carrocerías Cárdenas',
  'Carrocerias Cruz',
  'Carrocerías Fainsa',
  'Carrocerías La Itaugüeña',
  'Carrocerias Larenses',
  'Carrocerías Logos',
  'Carrocerías Metálicas Moncayo',
  'Carrocerías Paraná',
  'Carrocerias Parehara',
  'Carrocerías Piribebuy',
  'Carrocerias Polletti',
  'Carrocerias Rivas',
  'Carrocerías San Antonio - Paraguay',
  'Carrocerías Tarma',
  'Carrocerías Yaguareté',
  'Carrus',
  'Casa',
  'Casacar',
  'Castrosua',
  'Catelli & Hennemann',
  'Catosa',
  'Cebra',
  'Cebra Moreno',
  'Cermava',
  'Champion Bus',
  'Changan',
  'Chevrolet',
  'Chunzhou',
  'CiccoBus',
  'Cicol',
  'CIE',
  'Ciferal',
  'Ciferal Paulista',
  'Cinca',
  'Ciplasa',
  'Cirb',
  'Citroën',
  'Clave 7',
  'CMA',
  'CMTC',
  'Cobrasma',
  'Cobus',
  'Collins',
  'Colon Bus',
  'Comfort',
  'Comil',
  'Condor',
  'Contibuss',
  'Coopesa',
  'Cribia',
  'Crossley',
  'Crown',
  'CSR Times Bus',
  'Ctude',
  'Cuatro Ases',
  'Custom Denning',
  'CUTCSA',
  'Daewoo',
  'Daimler',
  'Dalla Via',
  'Davalos',
  'De Simon',
  'Decândia',
  'Decaroli',
  'Dennis Specialist Vehicles',
  'Denway',
  'Designline',
  'DIC',
  'Diegoli',
  'DIMEX',
  'DINA',
  'Dongfeng',
  'Drimbus',
  'Drögmöller',
  'Eagle Bus',
  'East Lancashire',
  'East Lancs',
  'Eastern Coach Works',
  'Ebusco',
  'El 14',
  'El Detalle',
  'El Diseño',
  'ElDorado',
  'Eliziário',
  'Ellobus Silver Road',
  'Encava',
  'Engerauto',
  'EOS',
  'Ernst Auwärter',
  'Eurobus',
  'Eurobus Argentina',
  'Eurocar',
  'Evelio Prieto Guillama',
  'EVM Minibus Conversions',
  'Evobus',
  'Explobus',
  'Fabusforma',
  'Facansa',
  'Facometal',
  'Famet',
  'Fanabus',
  'Farebus',
  'Faw Bus & Coach',
  'Fernandéz',
  'Ferqui',
  'FIAT',
  'Fleetwood',
  'Flxible',
  'Ford',
  'Foton',
  'FrankCar',
  'Furcare - Nimbus',
  'GAF',
  'Galicia',
  'GAZ-Palovo',
  'Gillig',
  'Girón',
  'GMC',
  'Godoy',
  'Golden Dragon',
  'Grassi',
  'Gruau',
  'Guararapes',
  'Güleryüz',
  'GVM Bus',
  'Hengtong Bus',
  'Hennemann',
  'Hess',
  'Heuliez',
  'Higer',
  'Hino',
  'Hispano',
  'Hobby Trailers',
  'Holiday Rambler',
  'Homecar',
  'Huanghai',
  'Hymer',
  'Hyundai',
  'Ibimco',
  'IBRAVA',
  'IFN - Indústria Ferroviária Nacional',
  'Ikarus',
  'IMCE',
  'Imeca',
  'Imetam',
  'Incabasa',
  'Incasel',
  'Increal',
  'Indcar',
  'Independência',
  'Industreiler',
  'Inrecar',
  'Intercar',
  'International',
  'Invecar',
  'INVEL',
  'Irisbus',
  'Irizar',
  'Irmãos Mota',
  'Isasi',
  'Isuzu',
  'Italbus',
  'Itapoã',
  'Iveco',
  'J.D. Martins',
  'JAC Ankai',
  'JGB',
  'Jinghua',
  'Jonckheere',
  'Jotave',
  'Kaiper Motorhomes',
  'Karosa',
  'Karsan',
  'Kässbohrer Setra',
  'Kawasaki Motors',
  'Kia Motors',
  'King Long',
  'Kossbus',
  'Kutsenits',
  'La Favorita',
  'Lahden',
  'Lahti',
  'Laika',
  'LAZ',
  'Le Voyageur',
  'Leyland',
  'Liderbus',
  'Lins Ônibus',
  'Loma Grande - El 11',
  'LR Bus - Carrocerías Leopoldo Rivera',
  'Lucero',
  'Ludewig',
  'Luhrs',
  'Mafersa',
  'Magirus-Deutz',
  'MAN',
  'Marcopolo',
  'Marielbus',
  'Marmon-Herrington',
  'Masa',
  'Mascarello',
  'Massari',
  'Massey',
  'Materfer',
  'MAUCO',
  'Maxibus',
  'MCI',
  'MCV',
  'MCW',
  'Menarini',
  'Mercedes-Benz',
  'Metalbus',
  'Metalicas Paper`s',
  'Metalicas Pillapa',
  'Metalpar',
  'Metalsur',
  'Metropolitana',
  'Milenio',
  'Miral',
  'Mitsubishi',
  'Mobipeople',
  'Mocelin',
  'Modasa',
  'Modasa-Huanghai',
  'Mopar',
  'Morillas',
  'Mount Cook',
  'MOV',
  'NABI',
  'Naves',
  'NAW/Hess/Siemens',
  'Neobus',
  'Neocar',
  'Neoplan',
  'Neostar',
  'New Flyer',
  'Neway',
  'Newmar',
  'Niccolo',
  'Nicola',
  'Nielson',
  'Nissan',
  'Nissan - (116 - Duplicado)',
  'Noge',
  'Nolbus',
  'Nortebus',
  'Northern Counties',
  'Nova Bus',
  'Novacapre',
  'NuovoBus',
  'NZMB',
  'Obradors',
  'OISA',
  'Operbus',
  'Optare',
  'Orejano',
  'Orenstein & Koppel',
  'Orion',
  'Orlandi',
  'Oshkosh',
  'Otokar',
  'Ott',
  'Ottaviano',
  'OVI',
  'Pacame',
  'Padane',
  'Patty',
  'Pavlovo Bus',
  'Phoenix',
  'Piasson',
  'Pilares',
  'Planet Bus',
  'Plaxton',
  'Portesi',
  'Porvenir',
  'Prevost',
  'Pullman Standard',
  'Pybus',
  'Rapido',
  'RECASA',
  'Reco',
  'Refam',
  'Renault',
  'Rio de La Plata',
  'Río Grande',
  'Riverlee Motor Bodies',
  'Rocar Autodromo',
  'Rosmo',
  'Ruvicha',
  'S.I.',
  'Saez Lopes',
  'Salabus',
  'Saldivia',
  'Salinas',
  'Salinas Moreno',
  'Salvador Caetano',
  'San Antonio',
  'San Jorge',
  'San Miguel',
  'Sanabria',
  'Sanchez Tatti',
  'Santa Matilde',
  'Santani',
  'SARO',
  'Saurer',
  'SC Chivalrous',
  'Scania',
  'SCC',
  'Scheid',
  'Servibus',
  'Setra',
  'Shangrao',
  'Sinotruk',
  'Sitcar',
  'Skoda',
  'Skywell',
  'Solaris',
  'SOMUA',
  'Spartan',
  'Stanford',
  'Striuli',
  'Sudamericanas',
  'Sulamericana',
  'Sultana',
  'Sunlong',
  'Sunsundegui',
  'Sunwin',
  'Superior',
  'Superior Coach USA',
  'Switch Mobility',
  'TAM',
  'Tata Hispano',
  'Tata Motors',
  'Tatsa',
  'Tecnobus',
  'Tecnobus Itália',
  'Tecnotrailer',
  'Tectran',
  'Temobuses',
  'Temsa',
  'Thamco',
  'Thomas',
  'Thor Motor Coach',
  'Tiffin Motorhomes',
  'TMG',
  'Todo Bus',
  'Toniutti',
  'Tourlife',
  'Toyota',
  'Trailcar',
  'Trailemar',
  'Travco',
  'TRI',
  'Trollybus',
  'Troyano',
  'TTC',
  'Tudonibus',
  'Turiscar',
  'Ugarte',
  'Unibuss',
  'Unicar',
  'Unisaúde',
  'UNVI',
  'UTIC',
  'UVG',
  'VanHool',
  'Vázquez',
  'VBK',
  'VDL Berkhof',
  'VDL Bus Coach',
  'Veera Vahana',
  'Vegutzi',
  'Veguzti',
  'Vettura',
  'Vieira',
  'Volare',
  'Volgren',
  'Volkswagen',
  'Volvo',
  'Walkbus',
  'Ward',
  'Wayne',
  'Winnebago',
  'Wrightbus',
  'Wrigth',
  'Yaxing',
  'Yeates',
  'Youngman',
  'Yutong',
  'Zanello',
  'Zhongtong'
]

export default carroceria
